import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ChevronDownOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ChevronDownOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m19 8.18-7 5.15-7-5.15v2.48l7 5.16 7-5.16V8.18Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ChevronDownOutlined;